import { render, staticRenderFns } from "./SKAMP.vue?vue&type=template&id=665672bc&scoped=true"
import script from "./SKAMP.vue?vue&type=script&lang=js"
export * from "./SKAMP.vue?vue&type=script&lang=js"
import style0 from "./SKAMP.vue?vue&type=style&index=0&id=665672bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665672bc",
  null
  
)

export default component.exports